import React from "react";
import { Box, Typography, Avatar, Divider } from "@mui/material";
import IReview from "models/Reviews";

interface EvaluationHeaderProps {
  review: IReview;
}

const EvaluationHeader:React.FC<EvaluationHeaderProps> = ({review}) => {
  return (
    <Box display="flex" alignItems="center" sx={{ mb: 3 }}>
      <Avatar
        src={review?.user?.profile_image}
        alt={`${review?.user?.first_name} ${review?.user?.last_name}`}
        sx={{ width: "60px", height: "60px", alignSelf: "start" }}
      />
      <Box sx={{ ml: 3 }}>
        <Typography variant="h6" sx={{ fontSize: "26px" }}>
          Performance Evaluation Of {review?.user?.first_name} {review?.user?.last_name}
        </Typography>
        <Divider sx={{ borderBottomWidth: "2px", mb: 1 }} />
        <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: 800, opacity: 0.8, mb: 2 }}>
          This review began on July 22,2023 4:00pm
        </Typography>
        <Box display="flex" alignItems="center">
          <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 800 }}>
            Form
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 2 }}>
            Manager Assessment Form
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 800 }}>
            Current Author
          </Typography>
          <Box display="flex" alignItems="center" sx={{ ml: 2 }}>
            <Avatar
              src={review?.user?.line_manager?.profile_image}
              alt={`${review?.user?.line_manager?.first_name} ${review?.user?.line_manager?.last_name}`}
            />
            <Typography variant="h6" sx={{ fontSize: "16px", ml: 1 }}>
              {`${review?.user?.line_manager?.first_name} ${review?.user?.line_manager?.last_name}`}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 800 }}>
            Due for authors
          </Typography>
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 2 }}>
            September 9,2022 4:00pm
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default EvaluationHeader;
